<script setup lang="ts">
import TheNavbar from "@/modules/landing/components/TheNavbar.vue";
import TheHero from "@/modules/landing/components/TheHero.vue";
import TheCompare from "@/modules/landing/components/TheCompare.vue";
import TheFeatures from "@/modules/landing/components/TheFeatures.vue";
import TheSteps from "@/modules/landing/components/TheSteps.vue";
import TheCta from "@/modules/landing/components/TheCta.vue";
import TheFooter from "@/modules/landing/components/TheFooter.vue";
</script>

<template>
  <VMain class="bg-secondary">
    <TheNavbar />

    <TheHero />
    <TheCompare />
    <TheFeatures />
    <TheSteps />
    <TheCta />
    <TheFooter />
  </VMain>
</template>
